import client from '../client';

const PATH = '/classifications'
const PATH_DATES = PATH + '/dates'

/**
 * Get the classifications of the seller.
 * It gets the categories as `{id, name, parentId}`.
 * @param {Object} payload
 * @param {String} payload.seller The id of the seller to get its categories.
 * @param {String} payload.date The date in format YYYY-MM-DD of creation of the classifications.
 * be got as a tree of categories.
 */
function get({ seller, date } = {}) {
  return client.get(PATH, { params: { date, seller } }).then(({ data }) => data)
}

/**
 * Get the available dates for the given seller.
 * @param {Number} seller The id of the seller.
 */
function getDates(seller) {
  return client.get(PATH_DATES, { params: { seller } }).then(({ data }) => data)
}

/**
 * Get a page with products of the given classification.
 * @param {Object} params
 * @param {Number} id The classification's id.
 * @param {Number} page The page to get.
 */
function getProducts({ id, page = 1 } = {}) {
  return client.get(`${PATH}/${id}/products`, { params: { page } }).then(({ data }) => data)
}

/**
 * Get 20 random products as samples of the classification extracted from QMatchingItemClassification.
 * @param {Number} id The classification's id to get the samples from.
 */
function getSamples(id, value) {
  return client.get(`${PATH}/${id}/samples${value != null ? "?value=" + value : ""} `).then(({ data }) => data);
}

function getClassificationRanking() {
  return client.get(`/classRanking`).then(({ data }) => data);
}

export default {
  get,
  getDates,
  getProducts,
  getSamples,
  getClassificationRanking
}
